<template>
  <simple-list
    ref="list"
    :default-limit="4"
    class="upcoming-stays"
  >
    <!-- Card Template -->
    <template v-slot:card-template="{ item }">
      <ul class="my-5">
        <li v-for="prop in Object.keys(item)" :key="prop">
          <template v-if="prop === 'ImageUrl'">
            <img :src="item[prop]" alt="">
          </template>
          <template v-else>
            <strong>{{prop}}:</strong> {{item[prop]}}
          </template>
        </li>
      </ul>
    </template>

    <!-- No items slot -->
    <template v-slot:no-items>
      <div class="no-items">
        {{noItemsText}}
      </div>
    </template>

    <!-- Default Slot -->
    <template v-slot:default>
      <div class="no-items">
        {{statusMessage}}
        <loading-dots v-if="isLoading" />
      </div>
    </template>

  </simple-list>
</template>

<script>
import axios from 'axios'

export default {
  name: 'upcoming-stay',
  props: {
    noItemsText: {
      type: String,
      default: 'No reservations found'
    },
    loadingItemsText: {
      type: String,
      default: 'Checking for upcoming stays'
    }
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    statusMessage() {
      return this.isLoading ? this.loadingItemsText : this.noItemsText
    }
  },
  async mounted() {
    await this.checkReservations()
    this.isMounted = true
  },
  methods: {
    async checkReservations() {
      this.isLoading = true
      const url = process.env.API_URL + 'api/v1/booking/reservations'
      const { data } = await axios.post(url, {})
      this.$refs.list.loadItems({ items: data, total: data.length })
      this.isLoading = false
    }
  }
}
</script>